import { SetGameHover } from '../actions/Main.actions';
import { InitialMainState } from './Main.state';
import { createReducer } from '@reduxjs/toolkit';

export const MainReducer = createReducer(InitialMainState, (builder) => {
  builder.addCase(SetGameHover, (state, { payload }) => {
    state.gameSwitcherHover = payload;
  });
});
